import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTranslateByKey } from '@/main/services/utils';
import SectionParameter from '../../../../../components/shared/tabs/insurer/tabSettingRegister/sectionParameter/sectionParameter';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Button from '@/main/components/shared/button/button';
import { ParameterTypesResponse } from '@/main/models/response/parameterTypesResponse';
import { getParameters, useParameterReducer } from '@/main/store/parameter';
import { ParameterFilterRequest } from '@/main/models/request/parameterFilterRequest';
import { SystemApplicationEnum } from '@/main/services/enum/SystemApplicationEnum';
import { ParameterTypeValueEnum } from '@/main/services/enum/ParameterTypeValueEnum';
import * as SP from '@/main/components/shared/styles';
import * as S from './styles';
import { checkParametersChange } from '@/main/components/shared/tabs/insurer/tabSettingRegister/utils';
import { parameterApi } from '@/main/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { resetReducerParameterTypeValue } from '@/main/store/parameterTypeValue';
import SpecialAccountsGrid, {
  ISpecialAccount
} from '@/main/components/shared/specialAccountsGrid/specialAccounts';
import SpecialAccountsModal from '@/main/components/shared/specialAccountsModal/specialAccountsModal';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { getUsersByInsurer, useInsurerReducer } from '@/main/store/insurer';
import { UsersByInsurerFilterRequest } from '@/main/models/request';
import { SpecialAccountApi } from '@/main/api/specialAccountApi';
import { CustomError } from '@/main/services/class/customError';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';

import DamageCategorySidebar from './damageCategorySideBar/damageCategorySideBar';
import DamageCategorySection from './damageCategorySection/damageCategorySection';
import { getDamageCategories } from '@/main/store/damageCategory';
import KogInputTextUnderline from '@/main/components/shared/inputText/inputTextUnderline';
import useAsyncModalConfirmReason from '@/main/components/shared/asyncModalConfirmReason/asyncModalConfirmReason';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import { toBase64 } from '@/main/services/utilsFile';

interface ITabInsurerClaimConfigurations {
  guidInsurer: string | null | undefined;
  guidCompany: string | null | undefined;
}

interface ISpecialAccountResponse {
  guid: string;
  guidInsurer: string;
  name: string;
  agentKey: string;
  totalLossPercentage?: number | null;
  users: Array<{
    guidSpecialAccountUser?: string;
    idUser: string;
    name: string;
  }>;
}

interface ISpecialAccountFormData {
  guidInsurer: string
  guid?: string;
  name: string;
  agentKey: string;
  totalLossPercentage?: number | null;
  users: Array<{
    guidSpecialAccountUser?: string
    idUser: string
    name: string
  }>
}

interface ISpecialAccountFormData {
  guidInsurer: string
  guid?: string;
  name: string;
  agentKey: string;
  totalLossPercentage?: number | null;
  users: Array<{
    guidSpecialAccountUser?: string
    idUser: string
    name: string
  }>
}

export function TabInsurerClaimConfigurations({
  guidInsurer = null,
  guidCompany = null
}: ITabInsurerClaimConfigurations) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { parameters: parameterReducer } = useParameterReducer();
  const { usersByInsurerFull } = useInsurerReducer();
  const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();

  const [renderModal, setRenderModal] = useState<React.ReactNode>([]);

  const [open, setOpen] = useState<boolean>(false);
  const [searchGridSpecialAccount, setSearchGridSpecialAccount] = useState<string>('');

  const [hasEdit, setHasEdit] = useState<boolean>(false);
  const [specialAccountEdit, setSpecialAccountEdit] = useState<ISpecialAccountFormData | null>(null);
  const [dataSpecialAccounts, setDataSpecialAccounts] = useState<ISpecialAccount[]>([]);

  const specialAccountApi = new SpecialAccountApi();

  const [isLoadingSpecialAccounts, setIsLoadingSpecialAccounts] = useState<
    boolean
  >(false);

  const [shouldOpenModal, setShouldOpenModal] = useState<boolean>(false);

  const lowercaseValues = (parameterTypes: ParameterTypesResponse[]) => {
    return parameterTypes.map(data => ({
      ...data,
      parameters: data.parameters.map(parameter => {
        if (
          data.idParameterTypeValue === ParameterTypeValueEnum.Boolean &&
          parameter.value
        ) {
          return {
            ...parameter,
            value: parameter.value.toLowerCase()
          };
        } else {
          return {
            ...parameter
          };
        }
      })
    }));
  };

  const [dataParameterTypes, setDataParameterTypes] = useState<
    ParameterTypesResponse[]
  >([]);

  const [
    damageCategoryEdit,
    setDamageCategoryEdit
  ] = useState<DamageCategoryResponse | null>(null);

  const [dataParametersScreen, setDataParametersScreen] = useState<
    ParameterTypesResponse[]
  >(lowercaseValues(dataParameterTypes));

  const [isLoadingSaveSettings, setIsLoadingSaveSettings] = useState<boolean>(
    false
  );
  const [openModalDamageCategory, setOpenModalDamageCategory] = useState<
    boolean
  >(false);

  useEffect(() => {
    if (guidCompany) {
      const request: ParameterFilterRequest = {
        guidCompany,
        applicationType: SystemApplicationEnum.Claims
      };

      dispatch(getParameters(request));
    }

    loadDamageCategories();
  }, []);

  useEffect(() => {
    if (guidInsurer) {
      const request: UsersByInsurerFilterRequest = {
        guidInsurer
      };

      dispatch(getUsersByInsurer(request));
    }
  }, [guidInsurer]);

  async function getSpecialAccountsData() {
    if (!guidInsurer) {
      setDataSpecialAccounts([]);
      return;
    }

    setIsLoadingSpecialAccounts(true);
    try {
      const response = await specialAccountApi.getSpecialAccount(guidInsurer);

      if (!response?.data?.result) {
        setDataSpecialAccounts([]);
        return;
      }

      const specialAccounts = response.data.result as ISpecialAccountResponse[];

      if (!Array.isArray(specialAccounts)) {
        setDataSpecialAccounts([]);
        return;
      }

      const formattedAccounts: ISpecialAccount[] = specialAccounts.map(
        account => ({
          guid: account.guid,
          guidInsurer: account.guidInsurer,
          name: account.name,
          agentKey: account.agentKey,
          totalLossPercentage: account.totalLossPercentage,
          users: account.users
        })
      );

      setDataSpecialAccounts(formattedAccounts);
    } catch (error) {
      setDataSpecialAccounts([]);
      if (error instanceof CustomError) {
        toast.error(
          error.message || getTranslateByKey('information.errorOccurred')
        );
      } else {
        toast.error(getTranslateByKey('information.errorOccurred'));
      }
    } finally {
      setIsLoadingSpecialAccounts(false);
    }
  }

  async function handleDeleteSpecialAccount(guid: string) {
    try {
      const accountToDelete = dataSpecialAccounts.find(
        account => account.guid === guid
      );

      if (!accountToDelete || !accountToDelete.guid) return;

      const resultConfirm = await getConfirmationReason(
        getTranslateByKey('information.confirmChangeTitle'),
        ReasonTypeEnum.ChangeCompany
      );

      if (!resultConfirm.confirmed) return;

      let filesRequest = undefined;
      if (resultConfirm.files && resultConfirm.files.length > 0) {
        filesRequest = await Promise.all(
          resultConfirm.files.map(async item => {
            const base64DataUrl = await toBase64(item);
            return {
              fileName: item.name,
              contentType: item.type,
              fileBase64: base64DataUrl as string
            };
          })
        );
      }

      const payload = {
        guidSpecialAccount: accountToDelete.guid,
        changeJustification: {
          guidReason: resultConfirm.reason ? String(resultConfirm.reason.key) : null,
          reasonDescription: resultConfirm.observation || null,
          filesUpload: filesRequest
        }
      };

      await specialAccountApi.deleteSpecialAccount(payload);

      setDataSpecialAccounts(prevState =>
        prevState.filter(account => account.guid !== guid)
      );

      toast.success(
        getTranslateByKey('information.specialAccountDeleteSuccessfully')
      );
    } catch (error) {
      if (error instanceof CustomError) {
        toast.error(error.message || getTranslateByKey('information.specialAccountDeleteError'));
      } else {
        toast.error(getTranslateByKey('information.specialAccountDeleteError'));
      }
    }
  }

  useEffect(() => {
    if (hasEdit) return;
    getSpecialAccountsData();
  }, [guidInsurer, hasEdit]);

  useEffect(() => {
    if (parameterReducer.data) {
      setDataParameterTypes(parameterReducer.data);
      setDataParametersScreen(lowercaseValues(parameterReducer.data));
    }
  }, [parameterReducer.data]);

  useEffect(() => {
    if (shouldOpenModal && specialAccountEdit) {
      openModal('specialAccounts');
      setShouldOpenModal(false);
    }
  }, [shouldOpenModal, specialAccountEdit]);

  function handleBack() {
    navigate(-1);
  }

  function closeModal() {
    setRenderModal(null);
    setOpen(false);
    setHasEdit(false);
    setSpecialAccountEdit(null);
  }

  function closeModalDamageCategory() {
    setOpenModalDamageCategory(false);
  }

  function loadDamageCategories() {
    if (guidInsurer) {
      dispatch(getDamageCategories(guidInsurer));
    }
  }

  async function handleSaveSettings() {
    setIsLoadingSaveSettings(true);
    const requestSaveParameters: { guid: string; value: string }[] = [];

    dataParametersScreen.map((x: any) => {
      x.parameters.map((y: any) => {
        return requestSaveParameters.push({
          guid: y.guid,
          value: y.value
        });
      });
    });

    try {
      let filesRequest = undefined;
      let guidReason = null;
      let reasonDescription = null;

      if (guidInsurer) {
        const resultConfirm = await getConfirmationReason(
          getTranslateByKey('information.confirmChangeTitle'),
          ReasonTypeEnum.ChangeCompany
        );

        if (!resultConfirm.confirmed) {
          setIsLoadingSaveSettings(false);
          return;
        }

        if (resultConfirm.files && resultConfirm.files.length > 0) {
          filesRequest = await Promise.all(
            resultConfirm.files.map(async item => {
              const base64DataUrl = await toBase64(item);
              return {
                fileName: item.name,
                contentType: item.type,
                fileBase64: base64DataUrl as string
              };
            })
          );
        }

        guidReason = resultConfirm.reason ? String(resultConfirm.reason.key) : null;
        reasonDescription = resultConfirm.observation || null;
      }

      const newRequest = {
        parameters: requestSaveParameters,
        changeJustification: {
          guidReason: guidReason,
          reasonDescription: reasonDescription,
          filesUpload: filesRequest
        }
      };

      await parameterApi.saveParameter(newRequest);
      toast.success(
        getTranslateByKey('information.parametersSavedSuccessfully')
      );
      dispatch(resetReducerParameterTypeValue());
      setDataParameterTypes(dataParametersScreen);
      setIsLoadingSaveSettings(false);
    } catch (error) {
    } finally {
      setIsLoadingSaveSettings(false);
    }
  }

  const disabledButtonSave = !checkParametersChange(
    dataParametersScreen,
    dataParameterTypes
  );

  function handleEditSpecialAccount(specialAccount: ISpecialAccount) {
    setSpecialAccountEdit(specialAccount);
    setHasEdit(true);
    setShouldOpenModal(true);
  }

  function openModal(nameProp: 'specialAccounts') {
    if (nameProp === 'specialAccounts') {
      setRenderModal(
        <SpecialAccountsModal
          guidInsurer={guidInsurer ?? ''}
          hasEdit={hasEdit}
          setHasEdit={setHasEdit}
          specialAccountEdit={specialAccountEdit}
          setOpen={setOpen}
          usersList={usersByInsurerFull.data}
          reloadData={getSpecialAccountsData}
        />
      );
      setOpen(true);
    }
  }

  function handleEditDamageCategory(damageCategory: DamageCategoryResponse) {
    setDamageCategoryEdit(damageCategory);
    setOpenModalDamageCategory(true);
  }

  function handleNewDamageCategory() {
    setDamageCategoryEdit(null);
    setOpenModalDamageCategory(true);
  }

  function handleChangeSearchGridSpecialAccount(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const newValue = event.target.value.toLowerCase();
    setSearchGridSpecialAccount(newValue);
  }

  const filteredSpecialAccounts = dataSpecialAccounts.filter(account =>
  searchGridSpecialAccount === '' ||
  account.name.toLowerCase().includes(searchGridSpecialAccount) ||
  account.agentKey.toLowerCase().includes(searchGridSpecialAccount) ||
  account.users.some(user =>
    user.name.toLowerCase().includes(searchGridSpecialAccount)
  )
);
  return (
    <>
      <S.Container>
        <S.ContainerSection>
          <SP.HeaderText>
            {getTranslateByKey('information.registerInsurerParameters')}
          </SP.HeaderText>
          <SectionParameter
            dataParameterAPI={dataParameterTypes}
            dataParametersScreen={dataParametersScreen}
            setDataParametersScreen={setDataParametersScreen}
          />
        </S.ContainerSection>

        {/* Damage Category */}
        <S.ContainerSection>
          <S.ContainerTitle>
            <SP.HeaderText>
              {getTranslateByKey('information.damageCategories')}
            </SP.HeaderText>
            <SecondaryButton
              id="id-damageCategory-add"
              style={{ padding: '.2rem .8rem', margin: '.5rem 0 0 .8rem' }}
              onClick={handleNewDamageCategory}>
              {getTranslateByKey('information.addCategory')}
            </SecondaryButton>
          </S.ContainerTitle>
          <S.ContainerBoxGrid>
            <DamageCategorySection
              guidInsurer={guidInsurer}
              handleEdit={handleEditDamageCategory}
              refreshData={loadDamageCategories}
            />
          </S.ContainerBoxGrid>
        </S.ContainerSection>

        {/* Special Accounts */}
        <S.ContainerSection>
          <S.ContainerTitle>
            <SP.HeaderText>
              {getTranslateByKey('information.specialAccounts')}
            </SP.HeaderText>
            <SecondaryButton
              id="id-register-btn-addSpecialAccount"
              style={{ padding: '.2rem .8rem', margin: '.5rem 0 0 .8rem' }}
              onClick={() => openModal('specialAccounts')}>
              {getTranslateByKey('information.specialAccountsAdd')}
            </SecondaryButton>
            <S.AreaFilterGridSpecialAccounts>
              <KogInputTextUnderline
                id="id-specialAccounts-search"
                label={getTranslateByKey('information.typeToFilter')}
                onChange={handleChangeSearchGridSpecialAccount}
                value={searchGridSpecialAccount}
              />
            </S.AreaFilterGridSpecialAccounts>
          </S.ContainerTitle>
          <S.ContainerBoxGrid>
            {isLoadingSpecialAccounts ? (
              <LoadingComponent />
            ) : (
              <>
                {dataSpecialAccounts.length > 0 && (
                  <SpecialAccountsGrid
                    data={filteredSpecialAccounts}
                    onEdit={handleEditSpecialAccount}
                    onDelete={handleDeleteSpecialAccount}
                  />
                )}
              </>
            )}
          </S.ContainerBoxGrid>
        </S.ContainerSection>

        <S.FooterButtons>
          <SecondaryButton
            type="button"
            onClick={handleBack}
            id="id-insurerClaimConfigurations-button-back">
            {getTranslateByKey('information.back')}
          </SecondaryButton>
          <Button
            id="id-insurerClaimConfigurations-button-save"
            type="submit"
            disabled={disabledButtonSave || isLoadingSaveSettings}
            isLoading={isLoadingSaveSettings}
            onClick={handleSaveSettings}>
            {getTranslateByKey('information.save')}
          </Button>
        </S.FooterButtons>
        <KogModalSideComponent open={open} closeModal={() => closeModal()}>
          {renderModal}
        </KogModalSideComponent>
        <ModalConfirmationReason />
      </S.Container>

      <DamageCategorySidebar
        open={openModalDamageCategory}
        closeModal={closeModalDamageCategory}
        guidInsurer={guidInsurer}
        damageCategoryEdit={damageCategoryEdit}
        loadGridList={() => {
          setDamageCategoryEdit(null);
          loadDamageCategories();
        }}
      />
    </>
  );
}
